var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dynamic-template',{attrs:{"template":_vm.html,"components":{ Slider: _vm.Slider, GamesList: _vm.GamesList, ProvablyFair: _vm.ProvablyFair, BonusCards: _vm.BonusCards, Raffles: _vm.Raffles }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }